import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { styled } from '@mui/material/styles'
import TablePagination from '@mui/material/TablePagination'
import Paper from '@mui/material/Paper'
import useMediaQuery from '@mui/material/useMediaQuery'
import NoRecordsFound from '../../atoms/NoRecordsFound'
import Loaders from '../Loaders'
import ProductListView from '../../../../product/components/organisms/Product/ProductListView'
import ProductListMobileView from '../../../../product/components/organisms/Product/ProductListMobileView'

const PREFIX = 'CustomTable'

const classes = {
    root: `${PREFIX}-root`,
    paper: `${PREFIX}-paper`,
    container: `${PREFIX}-container`,
    table: `${PREFIX}-table`,
    visuallyHidden: `${PREFIX}-visuallyHidden`,
}

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        width: '100%',
    },

    [`& .${classes.paper}`]: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },

    [`& .${classes.container}`]: {
        maxHeight: 440,
        '@media print': {
            maxHeight: '100%',
        },
    },

    [`& .${classes.table}`]: {
        minWidth: 750,
    },

    [`& .${classes.visuallyHidden}`]: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
}))

{/* prettier-ignore */}

const CustomTable = (props) => {
    const { t } = useTranslation()
    const [selected, setSelected] = useState([])
    const [dense, setDense] = useState(false)
    const [reload, setReload] = useState(false)
    const [tableBody, setTableBody] = useState(props.tableBody)
    const tableValues = props.tableValues
    const tableActions = props.tableActions
    const allData = props.allData
    const selectValues = props.selectValues
    const formik = props.formik
    const changeTableFunction = props.changeTableFunction
    const [showCompactView, setShowCompactView] = useState(true)
    const [allowFieldEdit, setFieldEdit] = useState(false)
    const [allowReorder, setAllowReorder] = useState(false)
    const [showPaginationView, setShowPaginationView] = useState(true)
    const [showPrint, setShowPrint] = useState(false)
    const [addFilter, setAddFilter] = useState(false)
    const [addFilterMap, setAddFilterMap] = useState(null)

    const [allDefaultFields, setAllDefaultFields] = useState([])
    const [allDynamicFields, setAllDynamicFields] = useState([])

    const [availableColumns, setAvailableColumns] = useState(props.tableValues)

    const isNotMobile = useMediaQuery('(min-width:767px)')

    useEffect(() => {
        setTableBody(props.tableBody)
        setSelected([])
        return () => {
            setSelected([])
        }
    }, [props.tableBody])

    useEffect(() => {
        if (props.denseVal) {
            setDense(props.denseVal)
        }

        if (props.hideCompactView) {
            setShowCompactView(false)
        }

        if (props.hidePaginationView) {
            setShowPaginationView(false)
        }

        if (props.showPrint) {
            setShowPrint(true)
        }

        if (props.additionalFilter) {
            setAddFilter(props.additionalFilter)
        }
        if (props.additionalFilterMapData) {
            setAddFilterMap(props.additionalFilterMapData)
        }
    }, [props])

    useEffect(() => {
        if (props.triggerTableActions) {
            props.triggerTableActions(selected)
        }
    }, [selected])

    useEffect(() => {
        setAvailableColumns(tableValues)
    }, [tableValues])

    useEffect(() => {
        if (props.searchData) {
            let values = props.searchData
            if (values.length) {
                const newSelecteds = []
                tableBody.map((item) => {
                    if (values.includes(item.id)) {
                        newSelecteds.push(item.id)
                    }
                })

                setSelected(newSelecteds)
            } else {
                setSelected([])
            }
        }
    }, [props.searchData])

    useEffect(() => {
        if (props.selectedUpdate) {
            props.selectedUpdate(selected)
        }
    }, [selected])

    const handleChangePage = (event, newPage) => {
        formik.page = newPage + 1
        changeTableFunction(formik)
    }

    const handleChangeRowsPerPage = (event) => {
        formik.limit = parseInt(event.target.value, 10)
        formik.page = 1
        changeTableFunction(formik)
    }

    const printRef = useRef()

    return (
        <Root className={classes.root} ref={printRef}>
            {props.isLoading ? (
                <Loaders
                    name={`${
                        props.loadingTemplate ? props.loadingTemplate : 'table'
                    }`}
                    isLoading={props.isLoading}
                />
            ) : (
                <>
                    {tableBody.length ? (
                        <>
                            <Paper className={classes.paper}>
                                {tableBody.map((row, indexhead) => {
                                    return isNotMobile ? (
                                        <ProductListView
                                            data={row}
                                            action={props.action}
                                            onSelectMultiProducts={
                                                props.onSelectMultiProducts
                                            }
                                            function={
                                                props.toggleFullScreenPopup
                                            }
                                            toggleBulkImagePopup={
                                                props.toggleBulkImagePopup
                                            }
                                            showProxyBid={true}
                                            noLocation={props.noLocation}
                                            noauction_image={
                                                props.noauction_image
                                            }
                                            noType={props.noType}
                                            noShowBid={props.noShowBid}
                                        />
                                    ) : (
                                        <ProductListMobileView
                                            data={row}
                                            action={props.action}
                                            onSelectMultiProducts={
                                                props.onSelectMultiProducts
                                            }
                                            function={
                                                props.toggleFullScreenPopup
                                            }
                                            toggleBulkImagePopup={
                                                props.toggleBulkImagePopup
                                            }
                                            showProxyBid={true}
                                            noLocation={props.noLocation}
                                            noauction_image={
                                                props.noauction_image
                                            }
                                            noType={props.noType}
                                            noShowBid={props.noShowBid}
                                        />
                                    )
                                })}
                                {showPaginationView && (
                                    <TablePagination
                                        labelRowsPerPage={t('Rows per page')}
                                        rowsPerPageOptions={
                                            formik.limitOptions
                                                ? formik.limitOptions
                                                : [
                                                      ...new Set([
                                                          5,
                                                          20,
                                                          40,
                                                          60,
                                                          100,
                                                          formik.limit,
                                                      ]),
                                                  ].sort((a, b) => a - b)
                                        }
                                        component="div"
                                        count={allData.totalRecords}
                                        rowsPerPage={formik.limit}
                                        page={formik.page - 1}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                        }
                                    />
                                )}
                            </Paper>
                        </>
                    ) : (
                        <NoRecordsFound />
                    )}
                </>
            )}
        </Root>
    )
}

export default CustomTable
